import Pusher from 'pusher-js';

let client: Pusher | null = null;

export function getPusher(): Pusher | null {
  if (typeof window === 'undefined') return null;
  if (client) return client;

  client = new Pusher(process.env.NEXT_PUBLIC_PUSHER_KEY!, {
    cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER!,
    forceTLS: true,
  });

  return client;
}

export const pusher = typeof window !== 'undefined' ? getPusher() : null;
